import {Component, inject, OnInit} from '@angular/core';
import {BaseRecordTableItemComponent} from "../../base-record-table-item/base-record-table-item.component";
import {allColors} from "../color-record-table-item-config";
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {Position} from "../../../../../types/position.types";
import {TableContextService} from "../../../../../services/table-services/table-context.service";

@Component({
  selector: 'app-color-record-table-modal',
  standalone: false,
  templateUrl: './color-record-table-modal.component.html',
  styleUrl: './color-record-table-modal.component.scss',
  providers: [ TableContextService ]
})
export class ColorRecordTableModalComponent extends BaseRecordTableItemComponent implements OnInit {
  public position: Position = { top: 0, left: 0 };

  protected readonly allColors = allColors;

  private dialogRef: MatDialogRef<ColorRecordTableModalComponent> = inject(MatDialogRef);
  private data = inject(MAT_DIALOG_DATA);

  public ngOnInit() {
    this.position = this.data.position;
  }

  public onBackdropClick() {
    this.dialogRef.close();
  }

  public handleInputEvent(event: Event) {
    const input = event.target as HTMLInputElement;
    this.value = input.value;
    this.closeModal(input.value);
  }

  public setColor(color: string) {
    this.value = color;
    this.closeModal(color);
  }

  private closeModal(value: string) {
    this.dialogRef.close(value);
  }
}
